<template>
  <div class="screenings container-div">
    <h1 class="small-h1 screening-h1">THEATRICAL SCREENINGS</h1>

    <div class="screening-row">
      <p class="screening-date screening-p"><strong>OCTOBER 12, 2026</strong></p>
      <p class="screening-location screening-p">La Crosse, WI</p>
      <p class="screening-venue screening-p">
        <strong><em><a href="https://www.rivoli.net/" target="_blank" rel="noopener noreferrer" class="screening-link">The Rivoli Theatre &amp; Pizzeria</a></em></strong>
      </p>
      <p class="screening-time screening-p">8:00 pm</p>
    </div>

    <div class="screening-row">
      <p class="screening-date screening-p"><strong>OCTOBER 9–10, 2026</strong></p>
      <p class="screening-location screening-p">Eau Claire, WI</p>
      <p class="screening-venue screening-p">
        <strong><em><a href="https://www.miconcinemas.com/theatres/micon-oakwood-mall/" target="_blank" rel="noopener noreferrer" class="screening-link">Micon Cinemas Oakwood</a></em></strong>
      </p>
      <p class="screening-time screening-p">Time TBD</p>
    </div>

    <div class="screening-row">
      <p class="screening-date screening-p"><strong>OCTOBER 9, 2026</strong></p>
      <p class="screening-location screening-p">Oshkosh, WI</p>
      <p class="screening-venue screening-p">
        <strong><em><a href="https://sawdustcityfrightfest.com/" target="_blank" rel="noopener noreferrer" class="screening-link">Sawdust City Fright Fest</a></em></strong>
      </p>
      <p class="screening-venue screening-p">
        <strong><em><a href="https://www.timecommunitytheater.com/" target="_blank" rel="noopener noreferrer" class="screening-link">Time Community Theatre</a></em></strong>
      </p>
      <p class="screening-time screening-p">Time TBD</p>
    </div>

    <div class="screening-row">
      <p class="screening-date screening-p"><strong>OCTOBER 2–8, 2026</strong></p>
      <p class="screening-location screening-p">Janesville, WI</p>
      <p class="screening-venue screening-p">
        <strong><em>Janesville Movies</em></strong>
      </p>
      <p class="screening-time screening-p">
        <a href="https://www.movies16janesville.com/" target="_blank" rel="noopener noreferrer" class="screening-link">Advanced Tickets Available Now</a>
      </p>
    </div>

    <div class="screening-row">
      <p class="screening-date screening-p"><strong>OCTOBER 1, 2026</strong></p>
      <p class="screening-location screening-p">Milwaukee, WI</p>
      <p class="screening-venue screening-p">
        <strong><em>Avalon Atmospheric Theatre</em></strong>
      </p>
      <p class="screening-time screening-p">7:00 pm</p>
    </div>

    <div class="screening-row">
      <p class="screening-date screening-p"><strong>JULY 18, 2026</strong></p>
      <p class="screening-location screening-p">Indianapolis, IN</p>
      <p class="screening-venue screening-p">
        <strong><em>Days of the Dead Film Festival</em></strong>
      </p>
      <p class="screening-venue screening-p">
        <strong><em>Indianapolis Marriott East</em></strong>
      </p>
      <p class="screening-time screening-p">12:00 pm</p>
    </div>

    <div class="screening-row">
      <p class="screening-date screening-p"><strong>MAY 28, 2026</strong></p>
      <p class="screening-location screening-p">Elroy, WI</p>
      <p class="screening-venue screening-p">
        <strong><em><a href="https://www.elroytheatre.com/" target="_blank" rel="noopener noreferrer" class="screening-link">The Elroy Theatre</a></em></strong>
      </p>
      <p class="screening-time screening-p">7:00 pm</p>
    </div>

    <div class="screening-row">
      <p class="screening-date screening-p"><strong>MAY 27, 2026</strong></p>
      <p class="screening-location screening-p">Watertown, WI</p>
      <p class="screening-venue screening-p">
        <strong><em><a href="https://www.towne-cinema.com/" target="_blank" rel="noopener noreferrer" class="screening-link">The Towne Cinema</a></em></strong>
      </p>
      <p class="screening-time screening-p">7:00 pm</p>
    </div>

    <div class="screening-row">
      <p class="screening-date screening-p"><strong>MARCH 21, 2026</strong></p>
      <p class="screening-location screening-p">Cincinnati, OH</p>
      <p class="screening-venue screening-p">
        <strong><em><a href="https://horrorhound.com/Events/FilmFest" target="_blank" rel="noopener noreferrer" class="screening-link">HorrorHound Film Festival</a></em></strong>
      </p>
      <p class="screening-venue screening-p">
        <strong><em><a href="https://sharonvilleconventioncenter.com/" target="_blank" rel="noopener noreferrer" class="screening-link">Sharonville Convention Center</a></em></strong>
      </p>
      <p class="screening-time screening-p">9:00 pm</p>
    </div>

    <div class="screening-row">
      <p class="screening-date screening-p"><strong>MARCH 6, 2026</strong></p>
      <p class="screening-location screening-p">Eau Claire, WI</p>
      <p class="screening-venue screening-p">
        <strong><em>A Night of Horror International Film Festival</em></strong>
      </p>
      <p class="screening-venue screening-p">
        <strong><em><a href="https://www.miconcinemas.com/theatres/micon-cinemas-eau-claire/" target="_blank" rel="noopener noreferrer" class="screening-link">Micon Cinemas</a></em></strong>
      </p>
      <p class="screening-time screening-p">12:00 pm</p>
    </div>

    <div class="screening-row">
      <p class="screening-date screening-p"><strong>NOVEMBER 7, 2025</strong></p>
      <p class="screening-location screening-p">Atlanta, GA</p>
      <p class="screening-venue screening-p">
        <strong><em><a href="https://buriedalivefilmfest.com/" target="_blank" rel="noopener noreferrer" class="screening-link">Buried Alive Film Festival</a></em></strong>
      </p>
      <p class="screening-venue screening-p">
        <strong><em><a href="https://www.plazaatlanta.com/" target="_blank" rel="noopener noreferrer" class="screening-link">The Plaza Theatre</a></em></strong>
      </p>
      <p class="screening-time screening-p">1:15 pm</p>
    </div>

  </div>
</template>

<script setup>
</script>

<style>
.screening-h1 {
    margin-bottom: 40px;
}
.screening-row {
  margin-bottom: 40px;
  text-align: center;
}

.screening-p {
  margin: 0;
  margin-bottom: 4px;
  font-family: "Pathway Gothic One", sans-serif;
  font-size: 22px;
  color: #ffffff;
}

.screening-link {
  color: #ffffff;
  text-decoration: underline;
  text-underline-offset: 3px;
  transition: opacity 0.2s ease;
}

.screening-link:hover {
  opacity: 0.7;
}
</style>
